module.exports = __webpack_public_path__ + "static/media/message-bubble.7cc52297.svg";